import { mapState, mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
    data () {
       return {
       }
    },

    methods: {
      /*
      ...mapActions('alert', ['setDismissSuccessCountDown', 'setLoading2', 'setLoaded2', 'setErrored', 'setErrored2', 'setMessage', 'setMessage2', 'setLoading', 'setLoaded']),
      ...mapActions('customer', ['getSites', 'getEmployees', 'getSettings', 'loadRules']),
      */

      numToColor(num) {
         //console.log('in numToColor', num);
         num >>>= 0;
         var b = num & 0xFF,
             g = (num & 0xFF00) >>> 8,
             r = (num & 0xFF0000) >>> 16,
             a = ( (num & 0xFF000000) >>> 24 ) / 255 ;
         return "color: rgba(" + [r, g, b, a].join(",") + ")";        
       },

       RGBAToHexA(rgba, forceRemoveAlpha = false) {
         return "#" + rgba.replace(/^rgba?\(|\s+|\)$/g, '') // Get's rgba / rgb string values
           .split(',') // splits them at ","
           .filter((string, index) => !forceRemoveAlpha || index !== 3)
           .map(string => parseFloat(string)) // Converts them to numbers
           .map((number, index) => index === 3 ? Math.round(number * 255) : number) // Converts alpha to 255 number
           .map(number => number.toString(16)) // Converts numbers to hex
           .map(string => string.length === 1 ? "0" + string : string) // Adds 0 when length of one number is 1
           .join("") // Puts the array to togehter to a string
       },       

      numToHex(num) {
        num >>>= 0;
        var b = num & 0xFF,
          g = (num & 0xFF00) >>> 8,
          r = (num & 0xFF0000) >>> 16,
          a = ((num & 0xFF000000) >>> 24) / 255;
        let rgba = "rgba(" + [r, g, b, a].join(",") + ")";
        return this.RGBAToHexA(rgba, true);
      },

      getOpNameFromOpNum(opNum) {
        if (this.practicePulseSettings && this.practicePulseSettings.allOps) {
          let op = this.practicePulseSettings.allOps.find(o => parseInt(o.OperatoryNum, 10) === parseInt(opNum, 10));
          if (op) {
            return op.OpName;
          }
        }
      },

      getEmployeeIDFromProvNum(provNum) {
        //console.log(`trying to find employeeID for provNum: ${provNum}`);
        let retVal = null;
        //console.log('all providers', this.providers);
        let provider = this.providers.find(p => p.ProvNum === provNum);
        //console.log('found provider', provider);
        if (provider) {
          // now find employee id from usernum
          //console.log('all employees', this.employees);
          let employee = this.employees.find(e => e.ODUserNum === provider.UserNum);
          //console.log('found employee', employee);
          if (employee) {
            retVal = employee.EmployeeID;    
          }
        }
        return retVal;
      }
    },

    computed: {
      ...mapGetters({
         'getProvColor' : 'customer/getProvColor',
         'getProviderFromEmployeeID': 'customer/getProviderFromEmployeeID'
      }), 

      opsWithoutCheckinCheckout() {
        if(this.pp && this.pp.ops) {
          let {checkin, checkout, ...rest} = this.pp.ops;          
          return rest;
        }
      },

      emptyOps() {
        if(this.pp && this.pp.ops) {
          let {checkin, checkout, ...rest} = this.pp.ops;  
          //console.log('rest', rest);      
          return _.pickBy(rest, function(key) {    
            //console.log('key', key);        
            if(key.length === 0)
              return true; 
          });
        }
      }
    }
}